import React from 'react'
// eslint-disable-next-line no-restricted-imports
import searchEmptyStateImage from 'images/search-history/empty-state-search.svg'
import {
  EmptyStateImage,
  EmptyStateWrapper,
  EmptyStateWrapperCompact,
  ParagraphEmptyState,
  TitleEmptyState
} from './SearchHistory.styles'
import { useTranslation } from 'i18n'

interface SearchHistoryEmptyStateProps {
  compact?: boolean
}

const SearchHistoryEmptyState = ({
  compact = false
}: SearchHistoryEmptyStateProps) => {
  const { t } = useTranslation()

  if (compact) {
    return (
      <EmptyStateWrapperCompact>
        <EmptyStateImage src={searchEmptyStateImage} alt="" />
        <TitleEmptyState size={3}>
          {t('Encontre o que você quer ler')}
        </TitleEmptyState>
        <ParagraphEmptyState>
          {t('Busque por autores, títulos, temas, categorias e muito mais.')}
        </ParagraphEmptyState>
      </EmptyStateWrapperCompact>
    )
  }

  return (
    <EmptyStateWrapper>
      <EmptyStateImage src={searchEmptyStateImage} alt="" />
      <TitleEmptyState size={3}>
        {t('Encontre o que você quer ler')}
      </TitleEmptyState>
      <ParagraphEmptyState>
        {t('Busque por autores, títulos, temas, categorias e muito mais.')}
      </ParagraphEmptyState>
    </EmptyStateWrapper>
  )
}

export default SearchHistoryEmptyState
